import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín',
  age: 37,
  location: 'Buenos Aires',
  text: 'Siempre pensaba que me faltaba resistencia. Descubrí que lo que me faltaba era entrenar mi cabeza.'
}, {
  name: 'Sofía',
  age: 34,
  location: 'Córdoba',
  text: 'Por primera vez disfruté una carrera sin estar peleando conmigo misma todo el tiempo.'
}, {
  name: 'Lucas',
  age: 41,
  location: 'Rosario',
  text: 'Aprendí a controlar la ansiedad antes de competir y bajé mi mejor tiempo en 10K.'
}, {
  name: 'Natalia',
  age: 29,
  location: 'Mendoza',
  text: 'Los ejercicios de respiración cambiaron completamente mis entrenamientos largos.'
}, {
  name: 'Federico',
  age: 45,
  location: 'Mar del Plata',
  text: 'Ahora cuando aparece el cansancio sé exactamente qué hacer para no abandonar mentalmente.'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-8 px-4 md:px-8 bg-ink text-white" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="text-center mb-6" data-id="element-133">
          <h2 className="font-display font-bold text-3xl md:text-5xl mb-6" data-id="element-134">
            Más de 1.200 runners ya entrenan su mente con este sistema
          </h2>
          <div className="flex justify-center gap-1 mb-4" data-id="element-135">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-136" />)}
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-137">
          {testimonials.map((t, idx) => <div key={idx} className="break-inside-avoid bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-138">
              <div className="flex gap-1 mb-4" data-id="element-139">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-140" />)}
              </div>
              <p className="text-lg italic text-white/90 mb-6" data-id="element-141">"{t.text}"</p>
              <div data-id="element-142">
                <p className="font-bold font-display" data-id="element-143">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sage text-sm" data-id="element-144">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}